import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleFollowingScreen() {
  return <PeopleScreen listType="following" />;
}
